export default "__VITE_ASSET__Ds2QcxcJ__"